var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.noLayout)?[_c('jm-header',{attrs:{"site":_vm.siteName}}),_c('jm-sidebar'),_c('router-view'),_c('jm-footer'),_c('jm-returnPage')]:[_c('router-view')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }